import I18n from '../../lib/i18n';

export type InitialStateType = Object[];

const initialState: InitialStateType = {
  pushNotifications: [],
  trpcNotifications: [],
};

export default (state: InitialStateType = initialState, action) => {
  switch (action.type) {
    case 'SET_TRIPICA_NOTIFICATIONS':
      return {
        ...state,
        trpcNotifications: action.payload.notifications.filter(notification =>
          I18n.has(`NOTIFICATION_${notification.type}`)
        ),
      };
    case 'SET_PUSH_NOTIFICATIONS':
      return { ...state, pushNotifications: action.payload.notifications };
    default:
      return state;
  }
};

export type NotificationStateType = {|
  pushNotifications: Object[],
  trpcNotifications: Object[],
|};
